// tslint:disable-next-line:import-name
import React, { ReactNode } from 'react';
import { UniqMotorcycle } from '../api/dmdcuData';
import { DmdcuDataContext } from '../api/dmdcuDataContext';
import { derivePKfromCodeWord } from './security';
import $ from 'jquery';
//import HtmlInputElement from 'dom';
import { GridLoader } from 'react-spinners';
import { async } from 'q';
import imgCamera from '../img/uniq_camera.jpg';


export interface IAssetEditorUIProps {
  motorcycle: UniqMotorcycle;
  dataContext: DmdcuDataContext;
}


export class AssetEditorUI extends React.Component<IAssetEditorUIProps> {

  codeword: string;
  isStoringOnBlockchain: boolean = false;
  storingOnBlockchainFailed: boolean = false;
  storingOnBlockchainError: string = '';

  handleCodewordChange = (e: React.FormEvent) => {
    const targetInput: any = e.target;
    this.codeword = targetInput.value;
  }

  handleTextChange = (e: React.FormEvent) => {

    const targetInput: any = e.target;
    // console.log('change ' + targetInput.name + 'to: ' + targetInput.value);
    this.props.motorcycle[targetInput.name] = targetInput.value;
    // console.log('motorcycle.name: ' + this.props.motorcycle.name, this.props.motorcycle);
  }

  handleNumberChange = (e: React.FormEvent) => {

    const targetInput: any = e.target;
    const number = Number.parseFloat(targetInput.value);

    if (!Number.isNaN(number) && (targetInput.value === number.toString())) {
      this.props.motorcycle[targetInput.name] = number;
    } else {
      targetInput.value = this.props.motorcycle[targetInput.name];
    }
    // console.log(this.props.motorcycle);
  }

  handleIntegerOptionChange = (e: React.FormEvent) => {

    const targetInput: any = e.target;
    const number = Number.parseInt(targetInput.value);
    

    if (!Number.isNaN(number) && (targetInput.value === number.toString())) {
      this.props.motorcycle[targetInput.name] = number;
    } else {
      throw Error('Unexpected Behavior: Option should always be an Integer.');
    }
    console.log(targetInput.value);
  }

  storeOnBlockchain() {
    if (this.isStoringOnBlockchain) {
      //catch multiple clicks 
      return;
    }
    this.isStoringOnBlockchain = true;
    this.storingOnBlockchainFailed = false;
    this.storingOnBlockchainError = '';

    const moto = this.props.motorcycle;
    let errorMessage = '';



    if (moto.imageRessourcesIPFSAddress.length === 0) {
      errorMessage = 'Please select a picture';
    }

    if (moto.horsepower === 0) {
      errorMessage = 'PS is required';
    }

    if (moto.topSpeed  === 0) {
      errorMessage = 'top speed is required';
    }

    if (moto.assetPlainText.length === 0) {
      errorMessage = 'Short description is required';
    }

    if (moto.name2.length === 0) {
      errorMessage = 'Model Base Name is required';
    }

    if (moto.name.length === 0) {
      errorMessage = 'Name customized is required';
    }

    
    if (errorMessage.length > 0) {
      this.isStoringOnBlockchain = false;
      this.storingOnBlockchainFailed = true;
      this.storingOnBlockchainError = errorMessage;
      this.forceUpdate();
      return;
    }

    console.log('submitting motorcycle to blockchain: ', this.props.motorcycle);
    derivePKfromCodeWord(this.codeword).then(async (pk) => {
      const impersonatedAccount = this.props.dataContext.impersonateViaPK(pk);
      console.log('impersonatedAccount: ', impersonatedAccount);

      this.props.dataContext.api.web3.eth.getBalance(impersonatedAccount).then((balance) => {
        console.log('got balance: ' + balance);
        if (balance === '0') {
          console.log('wrong password detected');
          this.isStoringOnBlockchain = false;
          this.storingOnBlockchainError = 'Wrong Password';
          this.storingOnBlockchainFailed = true;
          this.forceUpdate();
          return;
        }

        this.props.dataContext.addMotoToBlockchain(this.props.motorcycle).then(
          (s) => {
            const motoIDLink = UniqMotorcycle.getIDasHexValue(s.toNumber());
            console.log('Added moto to blockchain. id= ' + motoIDLink);
            window.location.hash = motoIDLink;
            this.isStoringOnBlockchain = false;
          },
          (f) => {
            this.isStoringOnBlockchain = false;
            this.storingOnBlockchainFailed = true;
            this.storingOnBlockchainError = 'Unexpected Error';
            console.error('Unable to add motorcycle to blockchain:', f);
            this.forceUpdate();
          },
        );
        this.forceUpdate();
      })
    });
  }

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.forceUpdate();
    console.log('calling store on blockchain');
    const promis = this.storeOnBlockchain();
    // promis.then(
    //   (s) => {
    //     console.log('storeONBlockchain Finished');
    
    //   },
    //   (f) => {
    //     $('body').removeClass('waiting');
    //   }
    // )
    console.log('called store on blockchain');
    this.forceUpdate();
  }

  render(): ReactNode {

    console.log('render got called: ');
    //this.isStoringOnBlockchain = true;

    // if (this.isStoringOnBlockchain) {
    //   return <section className="new-asset-loading">
    //   <div className="sectionInner">
    //     <div className="flexcenter"><GridLoader loading={true}
    //     sizeUnit={'px'}
    //     size={25}
    //     color={'#174578'}
    //     />
    //     </div>
    //     </div>
    //     </section>;
    // }

    // if (this.isStoringOnBlockchain) {
    //   return <div className="loadingAnimation"><GridLoader loading={true}
    //     sizeUnit={'px'}
    //     size={25}
    //     color={'#174578'}
    //     /></div>;
    // }

    return <section className="browser">
      <div className="sectionInner">
        <h1>Certify new asset</h1>
        <div className="clear"></div>
        <div className="newAssetForm">
          <form>
            <div className="formTextFields">
              <div className="formRow">
                <label className="label" htmlFor="name">Name Customized</label>
                <div className="field"><input type="text" name="name" onChange={this.handleTextChange} autoComplete="off" maxLength={20} placeholder="Max. 20 characters" /> </div>
              </div>
              <div className="formRow">
                <div className="label"><label htmlFor="model-base-name">Model Base Name</label></div>
                <div className="field"><input type="text" id="model-base-name" name="name2" autoComplete="off" maxLength={16} onChange={this.handleTextChange} placeholder="Max. 16 characters" /></div>
              </div>
              <div className="formRow">
                <div className="label"><label htmlFor="ps">PS</label></div>
                <div className="field"><input type="text" id="ps" name="horsepower" onChange={this.handleNumberChange} maxLength={4} placeholder="---" /></div>
              </div>
              <div className="formRow">
                <div className="label"><label htmlFor="topspeed">Top speed (in km/h)</label></div>
                <div className="field"><input type="text" id="topspeed" name="topSpeed" onChange={this.handleNumberChange} maxLength={4} placeholder="---" /></div>
              </div>
              <div className="formRow">
                <div className="label"><label htmlFor="original-build-date">Original build date</label></div>
                <div className="field"><input type="text" id="original-build-date" name="asset-original-build-date" maxLength={7} placeholder="MM/YYYY" /></div>
              </div>
              <div className="formRow formRow-select">
                <div className="label"><label htmlFor="form-customizationgrade">Customization grade</label></div>
                <div className="field">
                  <select id="form-customizationgrade" name="customizationGrade" onChange={this.handleIntegerOptionChange}>
                    <option value="">--</option>
                    <option value="1">Grade 1: 10-25%</option>
                    <option value="2">Grade 2: 25-50%</option>
                    <option value="3">Grade 3: 50-75%</option>
                    <option value="4">Grade 4: +75%</option>
                  </select>
                </div>
              </div>
              <div className="formRow formRow-select">
                <div className="label"><label htmlFor="form-vintagerating">Vintage rating</label></div>
                <div className="field">
                  <select id="form-vintagerating" name="vintageGrade" onChange={this.handleIntegerOptionChange}>
                    <option value="">--</option>
                    <option value="0">0 - No Vintage look</option>
                    <option value="1">1 - Vintage elements</option>
                    <option value="2">2 - True vintage look</option>
                  </select>
                  <p className="forminfo">
                    0: Vintage look is not part of this modification<br />
                    1: Vintage elements are existing, but some parts are still modern, like the base<br />
                    2: True vintage look, only possible if the whole cycle is vintage as well the base<br />
                  </p>
                </div>
              </div>
              <div className="formRow formRow-select">
                <div className="label"><label htmlFor="form-hightechrating">High-Tech rating</label></div>
                <div className="field">
                  <select id="form-hightechrating" name="techGrade" onChange={this.handleIntegerOptionChange}>
                    <option value="">--</option>
                    <option value="0">0 - Base model, no High-Tech modifications</option>
                    <option value="1">1 - modernized model </option>
                    <option value="2">2 - state of the art technology</option>
                  </select>
                  <p className="forminfo">
                    0: Base model with no hightech modifications<br />
                    1: modern impact is recognizable either old base with high tech extensions or a lot of technology remains despite the conversion<br />
                    2: state of the art technology for the customized year, no high-tech loss due to conversion
                    </p>
                </div>
              </div>
              <div className="formRow">
                <div className="label"><label htmlFor="name-shortdesc">Short Description</label></div>
                <div className="field"><input type="text" id="name-shortdesc" name="assetPlainText" maxLength={100} onChange={this.handleTextChange} placeholder="Max. 100 characters" /></div>
              </div>
              <div className="formRow monacoCode">
                <div className="label"><label htmlFor="monacoCode">Access Code for Monaco</label></div>
                <div className="field"><input type="password" autoComplete="off" id="monacoCode" name="asset-monacoCode" maxLength={10} placeholder="----------" onChange={this.handleCodewordChange} /></div>
              </div>
              <div className="submit_container">
                {this.isStoringOnBlockchain  ? <div className="loadingAnimation"><GridLoader loading={true}
        sizeUnit={'px'}
        size={25}
        color={'#174578'}
        /></div> : undefined}
                {this.storingOnBlockchainFailed ? <div className="storeOnBlockchainError">ERROR: {this.storingOnBlockchainError}</div> : undefined}
                
                <input type="submit" className="submit" value="Certify" onClick={this.handleSubmit} />
              </div>
            </div>
          </form>
          <div className="formUploadFields">
            <figure> <div className="selectedImageDisplayFrame"> <img className="selectedImageDisplay" src={imgCamera} /> </div> </figure>
            <h3 className="prevPhotosTitle">Your previous photos</h3>
            <div className="previousPhotos">
              <figure className="previousPhotoItem" id="CB-600-FA"><img src="assets/CB-600-FA.jpg" alt="Jill Valentine" /></figure>
              <figure className="previousPhotoItem" id="Black-Stallion"><img src="assets/Black-Stallion.jpg" alt="Black-Stallion" /></figure>
              <figure className="previousPhotoItem" id="Custom77"><img src="assets/Custom77.jpg" alt="Custom77" /></figure>
              <figure className="previousPhotoItem" id="Harley-Davidson-1200-CUSTOM"><img src="assets/Harley-Davidson-1200-CUSTOM.jpg" alt="Harley-Davidson-1200-CUSTOM" /></figure>
              <figure className="previousPhotoItem" id="TG-Mark-II"><img src="assets/TG-Mark-II.jpg" alt="TG-Mark-II" /></figure>
              <figure className="previousPhotoItem" id="Honda-CX500-1"><img src="assets/Honda-CX500-1.jpg" alt="Honda-CX500-1" /></figure>
              <figure className="previousPhotoItem" id="Honda-CX500-2"><img src="assets/Honda-CX500-2.jpg" alt="Honda-CX500-2" /></figure>
              <figure className="previousPhotoItem" id="Honda-CX500-3"><img src="assets/Honda-CX500-3.jpg" alt="Honda-CX500-3" /></figure>
              <figure className="previousPhotoItem" id="Honda-CX500-4"><img src="assets/Honda-CX500-4.jpg" alt="Honda-CX500-4" /></figure>
              <figure className="previousPhotoItem" id="Honda-CX500-5"><img src="assets/Honda-CX500-5.jpg" alt="Honda-CX500-5" /></figure>
            </div>

            <hr />
            {/* 
<h3>Upload documents</h3>
<p>(Certificates, Reports, etc ...)</p>
<form action="/file-upload" class="dropzone upload-documents" id="dropzone-document-upload"></form> */}
          </div>
          <div className="clear"></div>
        </div>
      </div>
    </section>;
  }

  componentDidMount() {

  /* Photo selection */
  //let photoSelectionCount = 0;

  // tslint:disable-next-line
  // $('.previousPhotos .previousPhotoItem').click( function(){
  //   console.log('clicki fotos...');
  //   if(photoSelectionCount < 5) {
  //     if($(this).hasClass('selected') === false) {
  //       photoSelectionCount++;
  //       $(this).addClass('selected');
  //       $(this).append(`<span class='photoSelectionCountNr'>${photoSelectionCount}</span>`)
  //       $(`input#selectedPhoto-${photoSelectionCount}`).val($(this).attr('id'));
  //     }
  //     if(photoSelectionCount === 5) {
  //       $('.previousPhotos .previousPhotoItem').addClass('deactivateCursor');
  //     }
  //   }
  // });
    const moto = this.props.motorcycle;
    const dataContext = this.props.dataContext;

    // tslint:disable-next-line
    $('.previousPhotoItem').click( function(){

      const imageID = $(this).attr('id');
      // console.log('imageID ' + imageID);
      $('.selectedImageDisplay').attr('src', `assets/${imageID}.jpg`);
      moto.imageRessourcesIPFSAddress = dataContext.api.web3.utils.fromUtf8(imageID);
      //console.log(moto.imageRessourcesIPFSAddress);
    });

  }
}

export default AssetEditorUI;